var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49511 0C7.36711 0 7.2336 0.0381819 7.1361 0.125454L2.78244 4.03178C2.65394 4.14678 2.52493 4.12542 2.42393 3.98997L0.925875 1.98089C0.77287 1.77589 0.452859 1.71862 0.223351 1.85544C-0.00565777 1.99226 -0.0696595 2.27817 0.0833461 2.48317L1.5809 4.49223C2.03191 5.09632 2.91045 5.17314 3.48497 4.65951L7.85412 0.76726C8.04863 0.592717 8.04863 0.299998 7.85412 0.125454C7.75662 0.0381819 7.62262 0 7.49511 0Z",
    fill: "#00C67F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.63ad084568f75a67099b4c4b173dd304.svg";
export { ForwardRef as ReactComponent };